import { ofType } from "redux-observable";
import { of } from "rxjs";
import { catchError, map, mergeMap, withLatestFrom } from "rxjs/operators";
import { IApplicationState } from "..";
import {
  ReturnsActionEnum,
  IFetchCapacityReturnsAction,
  ISubmitCapacityReturnAction} from ".";
import {
  FetchCapacityReturnsSuccessAction,
  FetchCapacityReturnsFailedAction,
  SubmitCapacityReturnSuccessAction,
  SubmitCapacityReturnFailedAction
} from "./ActionCreator";
import { CapacityReturnService } from "../../services/CapacityReturn.Service";

const capacityReturnService = new CapacityReturnService();

export const fetchSourceAuctionsEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(ReturnsActionEnum.FetchCapacityReturns),
    withLatestFrom(state$),
    mergeMap(([action, state]: [IFetchCapacityReturnsAction, IApplicationState]) => {
      return capacityReturnService.getSourceAuctionsForReturn(action.auction).pipe(
        map(response => {
          return FetchCapacityReturnsSuccessAction(response, action.auction);
        }),
        catchError(error => {
          console.error("Error fetching source auctions:", error);
          // Return the error action immediately to update UI
          const errorMessage = error.response?.data?.message || error.message || "Error fetching source auctions.";
          return of(FetchCapacityReturnsFailedAction(errorMessage));
        })
      );
    })
  );

export const submitCapacityReturnEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(ReturnsActionEnum.SubmitCapacityReturn),
    withLatestFrom(state$),
    mergeMap(([action, state]: [ISubmitCapacityReturnAction, IApplicationState]) => {
      return capacityReturnService.returnSubmission(action.request).pipe(
        map(response => {
          return SubmitCapacityReturnSuccessAction(response);
        }),
        catchError(error => {
          console.error(error);
          return of(SubmitCapacityReturnFailedAction(error.message || "Error submitting capacity return."));
        })
      );
    })
  );

export const returnsEpics = [fetchSourceAuctionsEpic, submitCapacityReturnEpic];
